/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCardHeaderTitle/view.blocks to change it.
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaCardHeaderTitle({
  children,
  viewPath = "/DesignSystem/TysiaCard/TysiaCardHeader/TysiaCardHeaderTitle",
  level = "h3",
  text = "Card"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="TysiaCardHeaderTitle.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level={level}
 marginTop={0}
 marginBottom={0}
 lineHeight="20px"
 text={text}
/>
</div>
{children}
</React.Fragment>)
}